<template>
  <main class="content">
    <!-- content -->
    <section class="add-one">
      <div class='container'>
        <div class="add-one__wrapper">
          <h1 class="add-one__title">Как это работает</h1>
          <div class="add-one__box">
            <div class="add-one__item">
              <div class="add-one__head">А</div>
              <div class="add-one__text">
                Больше не нужны дорогие юристы, не дающие гарантию и получающие огромные деньги. Выбирайте свою проблему и записывайтесь всего за 350 рублей.
              </div>
            </div>
            <div class="add-one__item">
              <div class="add-one__head">Б</div>
              <div class="add-one__text">
                Программа рассчитана на 1-2 часа и Вы онлайн полностью по косточкам разберетесь в том как выиграть именно Ваше дело.
              </div>
            </div>
            <div class="add-one__item">
              <div class="add-one__head">В</div>
              <div class="add-one__text">
                Вы все сможете сделать сами. На это и рассчитана программа – чтобы без обращения к юристам и без риска потерять деньги Вы сделали все сами более качественно.
              </div>
            </div>
          </div>
          <div class="add-one__box box-one">
            <div class="box-one__video">
              <iframe src="https://www.youtube.com/embed/cLPx7HrVta4"></iframe>
            </div>
            <div class="box-one__text text-one">
              <h4 class="text-one__title">Проверенные решения</h4>
              <p>
                Вам не нужно быть юристом для того чтобы выиграть свое дело.
              </p>
              <p>
                То, чему юристы и адвокаты учатся годами Вы получаете за пару часов. За 2 часа ничего лишнего – только то, что нужно вам для решения конкретного вопроса – будь то лишение прав, страховой спор или другой вопрос.
              </p>
              <p>
                Каждая тема – узкоспециализированная и основана на аналитике опыта юристов и адвокатов.
              </p>
              <p>
                Все материалы даются таким образом, чтобы в них было легко разобраться и это позволило вам выиграть свое дело.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
// import axios from '@/router/http'
export default {
  name: 'article',
  data () {
    return {
      article: {}
    }
  },
  components: {
    VRuntimeTemplate
  },
  methods: {
    initPage () {
    },
    showModal (id, text) {
      this.$root.requestModal = 1
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/how.vue